var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d21-back",class:{ active: _vm.isActive },on:{"click":_vm.back}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_forward")])])}
var staticRenderFns = []

export { render, staticRenderFns }